import { Box, LinearProgress } from "@mui/material";

// Keep children mounted while hidden: changing tabs or awaiting data must not
// discard a draft or restart the requests made by a child component.
export default function PvLoadingRegion({ loading = true, children, minHeight = 320, isGreek = false, label }) {
  return (
    <Box aria-busy={loading}>
      {loading && (
        <Box sx={{ minHeight, display: "flex", justifyContent: "center", alignItems: "center", bgcolor: "background.paper" }}>
          <LinearProgress
            aria-label={label || (isGreek ? "Φόρτωση…" : "Loading…")}
            sx={{
              width: 200, maxWidth: "70%",
              "@media (prefers-reduced-motion: reduce)": {
                "& .MuiLinearProgress-bar": { animation: "none", transform: "translateX(-50%)" },
              },
            }}
          />
        </Box>
      )}
      {children != null && <Box sx={{ display: loading ? "none" : "block" }}>{children}</Box>}
    </Box>
  );
}
